<!-- ── Company welcome hero ───────────────────────────────────────────────────── -->
<section class="tg-company-hero">
  <div class="tg-container">
    <div class="tg-company-hero__inner">
      <div class="tg-company-hero__content">
        <h1>Bienvenido, <span>{{usuario.user.nombre}}</span></h1>
        <p>Publica tus ofertas y contacta con los mejores profesionales de TI. Solo da clic en "Publicar Vacante", ingresa los datos y listo — miles de profesionales podrán verla.</p>
        <ul>
          <li>Publica tus vacantes y recibe candidatos rápidamente.</li>
          <li>Recluta talento de una manera fácil y eficiente.</li>
          <li>Da a conocer tus vacantes a miles de profesionales.</li>
        </ul>
        <a routerLink="/vacante/nuevo" class="tg-btn tg-btn--primary">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:16px;height:16px;margin-right:6px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
          </svg>
          Publicar Vacante
        </a>
      </div>

      <div class="tg-company-hero__img">
        <img loading="lazy" [src]="usuario.user.img" [alt]="usuario.user.nombre" [title]="usuario.user.nombre"
             onerror="this.src='assets/img/logo.png'">
      </div>
    </div>
  </div>
</section>

<!-- ── Featured candidates ───────────────────────────────────────────────────── -->
<div class="candidate-featured-container">
  <app-candidate-featured></app-candidate-featured>
</div>

<!-- ── Marketing section ─────────────────────────────────────────────────────── -->
<section class="tg-popular">
  <div class="tg-container">
    <div class="tg-popular__inner">

      <div class="tg-popular__imgs">
        <img loading="lazy" src="assets/img/home-3/3.jpg" alt="TG Empleos Empresa" title="TG Empleos Empresa">
        <div style="display:flex;flex-direction:column;gap:12px;">
          <img loading="lazy" src="assets/img/home-3/4.jpg" alt="TG Empleos Talento">
          <img loading="lazy" src="assets/img/home-3/5.jpg" alt="TG Empleos Profesionales">
        </div>
      </div>

      <div class="tg-popular__content">
        <h2>Con TG Empleos consigue al mejor talento humano.</h2>
        <p>En Tec Gurus te ayudamos a acercarte a los mejores profesionales para que alcances el éxito.</p>
        <ul>
          <li>Publica tus vacantes y recibe candidatos rápidamente.</li>
          <li>Recluta talento de una manera fácil.</li>
          <li>Da a conocer tus vacantes a miles de profesionales.</li>
        </ul>
        <p>En Tec Gurus sabemos la importancia de contar con el mejor talento humano, por ello hemos creado TG Empleos, tu mejor opción.</p>
        <a routerLink="/vacante/nuevo" class="tg-btn tg-btn--primary">Publicar ahora</a>
      </div>

    </div>
  </div>
</section>
